// extracted by mini-css-extract-plugin
export var border = "_a-8";
export var brand = "_a-t";
export var button = "_a-l";
export var center = "_a-a";
export var centered = "_a-6";
export var closeButton = "_a-c";
export var disabledWrapper = "_a-m";
export var error = "_a-p";
export var extraLarge = "_a-4";
export var extraSmall = "_a-1";
export var fill = "_a-i";
export var footer = "_a-h";
export var footerAction = "_a-j";
export var footerButtons = "_a-k";
export var header = "_a-7";
export var headerWithClose = "_a-d";
export var icon = "_a-o";
export var info = "_a-s";
export var inline = "_a-9";
export var large = "_a-3";
export var main = "_a-e";
export var modal = "_a-0";
export var nearFull = "_a-5";
export var neutral = "_a-u";
export var noPadding = "_a-g";
export var none = "_a-v";
export var scrollable = "_a-f";
export var small = "_a-2";
export var success = "_a-r";
export var tight = "_a-n";
export var titleIcon = "_a-b";
export var warn = "_a-q";